/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Experience_StoppedInputs */

const en_us2_onboarding_experience_stopped = /** @type {(inputs: Onboarding_Experience_StoppedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I used to train, but stopped`)
};

const pt_br2_onboarding_experience_stopped = /** @type {(inputs: Onboarding_Experience_StoppedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Já treinei, mas parei`)
};

const es_419_onboarding_experience_stopped = /** @type {(inputs: Onboarding_Experience_StoppedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrenaba, pero lo dejé`)
};

const pt_pt2_onboarding_experience_stopped = /** @type {(inputs: Onboarding_Experience_StoppedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Já treinei, mas parei`)
};

const fr_fr2_onboarding_experience_stopped = /** @type {(inputs: Onboarding_Experience_StoppedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je m'entraînais, mais j'ai arrêté`)
};

const de_de2_onboarding_experience_stopped = /** @type {(inputs: Onboarding_Experience_StoppedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Früher ja, aber aufgehört`)
};

const it_it2_onboarding_experience_stopped = /** @type {(inputs: Onboarding_Experience_StoppedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mi allenavo, ma ho smesso`)
};

/**
* | output |
* | --- |
* | "I used to train, but stopped" |
*
* @param {Onboarding_Experience_StoppedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_experience_stopped = /** @type {((inputs?: Onboarding_Experience_StoppedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Experience_StoppedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_experience_stopped(inputs)
	if (locale === "es-419") return es_419_onboarding_experience_stopped(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_experience_stopped(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_experience_stopped(inputs)
	if (locale === "de-DE") return de_de2_onboarding_experience_stopped(inputs)
	if (locale === "it-IT") return it_it2_onboarding_experience_stopped(inputs)
	return en_us2_onboarding_experience_stopped(inputs)
});
export { onboarding_experience_stopped as "onboarding.experience.stopped" }